export const PUBLIC_OFFER_RENDERERS = Object.freeze({
  HOTEL_OFFER: "hotel_offer",
  HERO_TEMPLATE_V1: "hero_template_v1",
  COMPARE_V2: "compare_v2",
  ORGANIZED_TOUR_V2: "organized_tour_v2",
  UNSUPPORTED: "unsupported",
});

/**
 * SSOT: public offer renderer selection.
 * Pure mapping only — no side effects.
 */
export function resolvePublicOfferRenderer(viewModel, offerPayload = null) {
  if (!viewModel || typeof viewModel !== "object") {
    return {
      renderer: PUBLIC_OFFER_RENDERERS.UNSUPPORTED,
      reason: "missing_view_model",
    };
  }
  const payload = offerPayload && typeof offerPayload === "object" ? offerPayload : {};
  if (viewModel?.version === 2 && viewModel?.offer_type === "organized_tour") {
    return {
      renderer: PUBLIC_OFFER_RENDERERS.ORGANIZED_TOUR_V2,
      reason: "organized_tour_v2",
    };
  }
  if (
    viewModel?.version === 2 &&
    (viewModel?.offer_type === "package_compare" ||
      viewModel?.offer_type === "hotel_compare")
  ) {
    return {
      renderer: PUBLIC_OFFER_RENDERERS.COMPARE_V2,
      reason: String(viewModel?.offer_type || "compare_v2"),
    };
  }
  const normalizedOfferType = String(
    viewModel?.offer_type ??
      viewModel?.offerType ??
      payload?.offer_type ??
      payload?.offerType ??
      payload?.template ??
      ""
  )
    .trim()
    .toLowerCase();
  const normalizedProductType = String(
    viewModel?.productType ??
      viewModel?.product_type ??
      payload?.productType ??
      payload?.product_type ??
      ""
  )
    .trim()
    .toLowerCase();
  if (
    normalizedOfferType === "hotel_offer" ||
    normalizedOfferType === "hotel" ||
    normalizedProductType === "hotel"
  ) {
    return {
      renderer: PUBLIC_OFFER_RENDERERS.HOTEL_OFFER,
      reason: normalizedOfferType || normalizedProductType || "hotel_offer",
    };
  }
  if (viewModel?.version === 1) {
    return {
      renderer: PUBLIC_OFFER_RENDERERS.HERO_TEMPLATE_V1,
      reason: "marketing_offer_v1_hero_template",
    };
  }
  return {
    renderer: PUBLIC_OFFER_RENDERERS.UNSUPPORTED,
    reason: "unknown_version_or_offer_type",
  };
}
